
/* keep EasySell's own cart line on the selected bundle (EasySell does not watch hidden id inputs) */
window.nvEsSync=window.nvEsSync||(function(){var t=null;return function(){clearTimeout(t);t=setTimeout(function(){try{var el=null,all=document.querySelectorAll('.es-form, .es-form *');for(var i=0;i<all.length;i++){if(all[i].__vue__&&all[i].__vue__.$store){el=all[i];break;}}var st=el&&el.__vue__.$store;if(st&&st._actions&&st._actions['cart/addVariantToCart'])st.dispatch('cart/addVariantToCart');}catch(e){}},60);};})();
/* NATURALVITA Women — page behaviour (scoped to .nv-page[data-nv-page]) */
(function(){
  var root=document.querySelector('[data-nv-page]');
  if(!root||root.dataset.nvInit)return; root.dataset.nvInit='1';
  function $$(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));}
  function $(s,c){return (c||root).querySelector(s);}
  function json(k){var e=$('script[data-nv-'+k+']');try{return e?JSON.parse(e.textContent):null}catch(x){return null}}
  var fmt=function(n){return String(Math.round(+n||0));};

  /* ---------- package / variant selection ---------- */
  var radios=$$('input[name="nv-package"]');
  var idInput=$('[data-nv-variant]')||$('form[data-nv-form] input[name="id"]');
  function select(id,opts){
    var r=radios.filter(function(x){return String(x.value)===String(id)})[0]; if(!r)return;
    radios.forEach(function(x){var on=x===r;x.checked=on;if(on)x.setAttribute('checked','');else x.removeAttribute('checked');var l=x.closest('label');if(l)l.classList.toggle('active',on);});
    var title=r.getAttribute('data-nv-title')||'', price=r.getAttribute('data-nv-price'), save=+(r.getAttribute('data-nv-save')||0);
    var cnt=r.getAttribute('data-nv-count')||'1';
    $$('[data-nv-sum-pack]').forEach(function(e){e.textContent=title+' · '+cnt+' عبوة';});
    $$('[data-nv-sum-price]').forEach(function(e){e.textContent=fmt(price);});
    $$('[data-nv-sum-total]').forEach(function(e){e.textContent=fmt(price);});
    $$('[data-nv-sum-save]').forEach(function(e){e.textContent=fmt(save);});
    $$('[data-nv-sum-saving-row]').forEach(function(e){e.hidden=!(save>0);e.style.display=save>0?'':'none';});
    $$('[data-nv-sticky-title]').forEach(function(e){e.textContent=title;});
    $$('[data-nv-sticky-price]').forEach(function(e){e.textContent=fmt(price);});
    var st=$('[data-nv-sticky]'); if(st)st.setAttribute('data-quantity',r.getAttribute('data-nv-count')||'1');
    $$('[data-nv-bundle]').forEach(function(a){a.classList.toggle('active',String(a.getAttribute('data-nv-bundle'))===String(id));});
    if(idInput&&String(idInput.value)!==String(id)){
      idInput.value=id; idInput.setAttribute('value',id);
      idInput.dispatchEvent(new Event('change',{bubbles:true}));
      idInput.dispatchEvent(new Event('input',{bubbles:true}));window.nvEsSync();
    }
    if(!(opts&&opts.silentUrl)){try{var u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(history.state,'',u.toString());}catch(e){}}
  }
  radios.forEach(function(r){r.addEventListener('change',function(){if(r.checked)select(r.value);});});
  $$('[data-nv-pick]').forEach(function(a){a.addEventListener('click',function(ev){
    select(a.getAttribute('data-nv-pick'));
    var t=document.getElementById('order'); if(t){ev.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
  });});
  var init=radios.filter(function(x){return x.checked})[0]||radios[0];
  if(init)select(init.value,{silentUrl:true});

  /* ---------- gallery ---------- */
  var G=json('gallery')||[], gi=0;
  var main=$('[data-nv-zoom]'), mainImg=main?$('img',main):null;
  var dlg=document.querySelector('dialog.image-dialog');
  function setImg(img,it,useMobile){ if(!img||!it)return;
    img.src=it.src; img.alt=it.alt||''; if(it.w){img.width=it.w;img.height=it.h;}
    if(useMobile&&it.mobile){img.srcset=it.mobile+' 760w, '+it.src+' 1254w';img.sizes='(max-width: 760px) 100vw, 50vw';}
    else {img.removeAttribute('srcset');img.removeAttribute('sizes');}
  }
  function show(i){ if(!G.length)return; gi=(i+G.length)%G.length; var it=G[gi];
    setImg(mainImg,it,true);
    if(main)main.setAttribute('aria-label','تكبير صورة '+(it.label||''));
    $$('[data-nv-thumb]').forEach(function(b){var on=+b.getAttribute('data-nv-thumb')===gi;b.classList.toggle('active',on);b.setAttribute('aria-pressed',on?'true':'false');});
    $$('span[data-nv-count]').forEach(function(s){s.textContent=(gi+1)+' / '+G.length;});
    if(dlg){var di=$('img',dlg);setImg(di,it,false);var sp=$('.image-dialog-controls span',dlg);if(sp)sp.textContent=(it.label||'')+' — '+(gi+1)+'/'+G.length;}
  }
  $$('[data-nv-thumb]').forEach(function(b){b.addEventListener('click',function(){show(+b.getAttribute('data-nv-thumb'));});});
  var pv=$('[data-nv-prev]'),nx=$('[data-nv-next]');
  if(pv)pv.addEventListener('click',function(){show(gi-1);});
  if(nx)nx.addEventListener('click',function(){show(gi+1);});
  if(main&&dlg){
    main.addEventListener('click',function(){show(gi);try{dlg.showModal();}catch(e){dlg.setAttribute('open','');}});
    var cb=$$('.image-dialog-controls button',dlg);
    if(cb[0])cb[0].addEventListener('click',function(){show(gi-1);});
    if(cb[1])cb[1].addEventListener('click',function(){show(gi+1);});
    var cl=$('.image-close',dlg); if(cl)cl.addEventListener('click',function(){dlg.close();});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close();});
    dlg.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(gi+1);if(e.key==='ArrowRight')show(gi-1);});
  }

  /* ---------- detail tabs ---------- */
  var T=json('tabs')||[], panel=document.getElementById('detail-panel');
  $$('[role="tab"]').forEach(function(t,i){t.addEventListener('click',function(){
    $$('[role="tab"]').forEach(function(x,j){x.setAttribute('aria-selected',j===i?'true':'false');x.tabIndex=j===i?0:-1;});
    if(panel&&T[i]!=null){panel.textContent=T[i];panel.setAttribute('aria-labelledby',t.id);}
  });});

  /* ---------- FAQ (single open) ---------- */
  var faqs=$$('.faq-item');
  faqs.forEach(function(item){var b=$('button',item);if(!b)return;b.addEventListener('click',function(){
    var open=b.getAttribute('aria-expanded')!=='true';
    faqs.forEach(function(o){var ob=$('button',o),p=document.getElementById(ob.getAttribute('aria-controls'));var on=open&&o===item;ob.setAttribute('aria-expanded',on?'true':'false');o.classList.toggle('open',on);if(p)p.hidden=!on;});
  });});

  /* ---------- mobile menu ---------- */
  var mb=$('.menu-btn'),nav=$('.nav');
  if(mb&&nav){mb.addEventListener('click',function(){var on=!nav.classList.contains('show');nav.classList.toggle('show',on);mb.setAttribute('aria-expanded',on?'true':'false');});
    $$('a',nav).forEach(function(a){a.addEventListener('click',function(){nav.classList.remove('show');mb.setAttribute('aria-expanded','false');});});}

  /* ---------- sticky order bar: hidden while the order form is on screen ---------- */
  var st=$('[data-nv-sticky]'),of=$('[data-nv-order]')||document.getElementById('order');
  if(st&&of){
    var updSt=function(){var b=of.getBoundingClientRect();var vis=b.bottom>0&&b.top<window.innerHeight;if(st.hidden!==vis){st.hidden=vis;st.setAttribute('aria-hidden',vis?'true':'false');}};
    window.addEventListener('scroll',updSt,{passive:true});window.addEventListener('resize',updSt);updSt();
  }
})();
/* EasySell: reference labels / button look. Order creation stays with EasySell. */
(function(){
  var root=document.querySelector('[data-nv-page]'); if(!root)return;
  var CFG={"fields":{"first_name":{"label":"الاسم واللقب","ph":"الاسم واللقب كاملين"},"phone":{"label":"رقم الهاتف","ph":"05 12 34 56 78","dir":"ltr"},"address":{"label":"الولاية والبلدية","ph":"مثال: سطيف — العلمة"}},"button":{"text":"اطلبي الآن — الدفع عند الاستلام","style":{"background":"rgb(64, 167, 84)","background-image":"none","color":"#fff","border-radius":"8px","font-size":"17px","font-weight":"700","padding":"13px 10px","border":"1px solid rgb(64, 167, 84)","width":"100%","font-family":"inherit"}}};
  function run(){
    var f=root.querySelector('.es-form'); if(!f)return;
    Object.keys(CFG.fields).forEach(function(n){
      var inp=f.querySelector('[name="'+n+'"]'); if(!inp)return; var d=CFG.fields[n];
      if(d.dir&&inp.getAttribute('dir')!==d.dir)inp.setAttribute('dir',d.dir);
      if(d.ph&&inp.getAttribute('placeholder')!==d.ph)inp.setAttribute('placeholder',d.ph);
      var lab=inp.id?f.querySelector('label[for="'+inp.id+'"]'):null;
      if(lab&&d.label){var tn=null;for(var i=0;i<lab.childNodes.length;i++){if(lab.childNodes[i].nodeType===3&&lab.childNodes[i].textContent.trim()){tn=lab.childNodes[i];break;}}
        if(tn&&tn.textContent.trim()!==d.label)tn.textContent=' '+d.label+' ';}
    });
    var b=f.querySelector('#es-form-button,.es-cta-btn');
    if(b){var st=CFG.button.style;Object.keys(st).forEach(function(k){if(b.style.getPropertyValue(k)!==st[k]||b.style.getPropertyPriority(k)!=='important')b.style.setProperty(k,st[k],'important');});
      var busy=b.disabled||b.querySelector('.spinner,.es-spinner,[class*=spin]');
      if(!busy&&b.textContent.trim()!==CFG.button.text)b.textContent=CFG.button.text;}
  }
  var t=null; function later(){clearTimeout(t);t=setTimeout(run,30);}
  new MutationObserver(later).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['style','placeholder','disabled']});
  run(); setTimeout(run,800); setTimeout(run,2500);
})();